import { AfterViewInit, Component, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { AuthService } from 'src/app/auth/auth.service';
import { UtilitieService } from '../services/utils/utilities.service';
@Component({
  selector: 'home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit, AfterViewInit, OnDestroy {
  isLoggedIn: boolean;
  homeImgUrl: string;
  private readonly destroy$ = new Subject<void>();

  constructor(
    private authService: AuthService,
    private renderer: Renderer2,
    private utilService: UtilitieService
  ) {
  }


  loadScript(src: string) {
    const script = this.renderer.createElement('script');
    script.src = src;
    script.type = 'text/javascript';
    script.async = true;
    script.defer = true;
    this.renderer.appendChild(document.body, script);
  }
  ngOnInit(): void {
    this.isLoggedIn = false;
    this.homeImgUrl = 'https://firebasestorage.googleapis.com/v0/b/av-s-emprize.appspot.com/o/yard_hostle%2Fhome_pic.png?alt=media&token=2aa6ccbd-f125-40d1-8c23-1937f8905fca';
    this.authService.getAuthState()
    .pipe(takeUntil(this.destroy$))
    .subscribe(isLoggedIn => {
      this.isLoggedIn = isLoggedIn !== null;
      
    });
    this.utilService.updateLoading(false);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngAfterViewInit(): void {
    this.loadScript('assets/dist/js/main.min.js');
  }


  testInstanceCreation() {

  }
}
